export const SyncSectionNameArray = ['INFO', 'PRICE', 'PICTURES', 'VIDEOS', 'FOSTER', 'DESCRIPTION', 'CHARACTERISTICS', 'ADOPTION_PATH', 'ALLOW_ADOPT_BUTTON', 'VISIBILITY'] as const
export type SyncSectionName = typeof SyncSectionNameArray[number]

export default interface IIntegrationSync {
  uuid: string,
  created_date: string,
  modified_date: string,
  version: number,
  finish: boolean,
  canceled: boolean,
  total: number,
  current: number,
  fails: number,
  process_time: number,
  filtered: number,
  new_pets: number,
  archived_pets: number,
  updated_pets: number,
  restored_pets: number,
  migrated_pets: number,
  type: string,
  force_sections: SyncSectionName | null,
  is_forced_sync: boolean
}